import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Link } from 'react-router'
import { autobind } from 'core-decorators'

import { formatDate, roundNumber } from '../../shared/utils'

const BlockRating = (props) => {
  return (
    <div>
      {Array(...Array(5))
        .map((val, i) => {
          const key = `block-${i}`
          const className = props.rating * 5 > i ? 'solid' : 'fade'
          return (
            <div
              key={key}
              className={`rating-block ${className}`}
            />
          )
        })}
    </div>
  )
}

BlockRating.propTypes = {
  rating: PropTypes.number
}

const StarRating = (props) => {
  return (
    <div>
      {Array(...Array(5))
        .map((val, i) => {
          const key = `star-${i}`
          const className = props.rating * 5 > i ? 'solid' : 'fade'
          return (
            <svg
              key={key}
              className={`rating-star ${className}`}
              width="18"
              height="18"
            >
              <use xlinkHref="#icon-star-color" />
            </svg>
          )
        })}
    </div>
  )
}

StarRating.propTypes = {
  rating: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
}

export default class ListEntry extends Component {

  static propTypes = {
    isActive: PropTypes.bool,
    onClick: PropTypes.func,
    rating: PropTypes.object.isRequired,
  }

  @autobind
  handleClick() {
    if (this.props.onClick) {
      this.props.onClick({
        target: {
          id: this.props.rating.id
        }
      })
    }
  }

  renderComment(comment) {
    const username = comment.user && comment.user.firstname || comment.user.surname
      ? [comment.user.firstname, comment.user.surname].join(' ')
      : 'anonym'

    return (
      <li
        key={comment.createdAt.date}
        className="iconized"
      >
        <strong className="message-type">
          <svg
            className="nav-list-icon"
            width="18"
            height="18"
          >
            <use xlinkHref="#icon-star-color" />
          </svg>
          {username}
          {comment.isFromTeacher ? ' (Lehrer)' : ''}
          , &nbsp;
          <span className="text-muted">
            am
            {formatDate(comment.createdAt.date)}
          </span>
        </strong>
        {comment.text || <i>Kein Kommentar</i>}
      </li>
    )
  }

  render() {
    const {
      rating: {
        offering,
        title,
        offeringId,
        offeringType,
        totalRatings,
        teacherRatings,
        pupilRatings,
        comments
      },
    } = this.props

    const userReadableOfferingType = offeringType === 'program' ? 'Programm' : 'Führung'
    const userReadableOfferingTypeLink = offeringType === 'program' ? 'zum Programm' : 'zur Führung'
    return (
      <li
        className={[
          this.props.isActive
            ? 'active'
            : ''
        ].join(' ')}
      >
        <h4
          onClick={this.handleClick}
        >
          {title}
          {' '}
          (
          {userReadableOfferingType}
          )
        </h4>
        <div>
          <Link to={`${offeringType}/${offeringId}`}>{userReadableOfferingTypeLink}</Link>
          &nbsp;.&nbsp;
          Museum:
          {' '}
          <Link to={`museum/${offering.museum.id}`}>{offering.museum.name}</Link>
        </div>
        <div className="row"
          onClick={this.handleClick}
        >
          <div className="col-xs-2">
            <ul>
              <li
                rel="tooltip"
                title={`Gesamteindruck aller Besucher ${roundNumber(totalRatings.percent.overallImpression * 5)} von 5`}
              >
                <StarRating rating={totalRatings.percent.overallImpression} />
              </li>
              <li
                rel="tooltip"
                title={`Gesamteindruck aller Lehrer ${roundNumber(teacherRatings.percent.overallImpression * 5)} von 5`}
              >
                <StarRating rating={teacherRatings.percent.overallImpression} />
              </li>
              <li
                rel="tooltip"
                title={`Gesamteindruck aller Schüler ${roundNumber(pupilRatings.percent.overallImpression * 5)} von 5`}
              >
                <StarRating rating={pupilRatings.percent.overallImpression} />
              </li>
            </ul>
          </div>
          <div className="col-xs-3">
            <ul className="text-muted">
              <li>
                {totalRatings.count}
                {' '}
                Bewertungen, davon
              </li>
              <li>
                {teacherRatings.count}
                {' '}
                Lehrer
              </li>
              <li>
                {pupilRatings.count}
                {' '}
                Schüler
              </li>
            </ul>
          </div>
          <div className="col-xs-3">
            <ul className="horizontal smileys">
              <li
                title="Hohe Weiterempfehlungsrate"
              >
                {(() => {
                  const state = totalRatings.percent.recommendationRate > 0.66
                  return (
                    <svg
                      className={`rating-star ${state ? 'solid' : 'fade'}`}
                      width="45"
                      height="45"
                    >
                      <use
                        xlinkHref={`#icon-smiley-${state ? 'color' : 'grey'}`}
                      />
                    </svg>
                  )
                })()}
              </li>
              <li
                title="Mittlere Weiterempfehlungsrate"
              >
                {(() => {
                  const state = totalRatings.percent.recommendationRate < 0.66
                  && totalRatings.percent.recommendationRate > 0.33
                  return (
                    <svg
                      className={`rating-star ${state ? 'solid' : 'fade'}`}
                      width="45"
                      height="45"
                    >
                      <use
                        xlinkHref={`#icon-smiley-ok-${state ? 'color' : 'grey'}`}
                      />
                    </svg>
                  )
                })()}
              </li>
              <li
                title="Niedrige Weiterempfehlungsrate"
              >
                {(() => {
                  const state = totalRatings.percent.recommendationRate < 0.33
                  return (
                    <svg
                      className={`rating-star ${state ? 'solid' : 'fade'}`}
                      width="45"
                      height="45"
                    >
                      <use
                        xlinkHref={`#icon-smiley-cry-${state ? 'color' : 'grey'}`}
                      />
                    </svg>
                  )
                })()}
              </li>
            </ul>
          </div>
          <div className="col-xs-4 text-muted">
            <span
              className="weighted"
            >
              {Math.round(totalRatings.percent.recommendationRate * 100)}
              %
            </span>
            <br />
            Weiterempfehlung
          </div>
        </div>

        <div className="row section details">
          <dl>
            <dt>Didaktisch-method. Aufbereitung</dt>
            <dd>
              <ul className="rating-chart">
                <li className="total">
                  <div className="rating-block-container"
                    title={`Insgesamt ${roundNumber(totalRatings.percent.didactically * 5)} Punkte von 5`}
                  >
                    <BlockRating rating={totalRatings.percent.didactically} />
                  </div>
                </li>
                <li>
                  <div className="rating-block-container"
                    title={`Bei Lehrern ${roundNumber(teacherRatings.percent.didactically * 5)} Punkte von 5`}
                  >
                    <BlockRating rating={teacherRatings.percent.didactically} />
                  </div>
                </li>
                <li>
                  <div className="rating-block-container"
                    title={`Bei Schülern ${roundNumber(pupilRatings.percent.didactically * 5)} Punkte von 5`}
                  >
                    <BlockRating rating={pupilRatings.percent.didactically} />
                  </div>
                </li>
              </ul>
            </dd>

            <dt>Vortragsart des Sprechers</dt>
            <dd>
              <ul className="rating-chart">
                <li className="total">
                  <div
                    className="rating-block-container"
                    title={`Insgesamt ${roundNumber(totalRatings.percent.presentation * 5)} Punkte von 5`}
                  >
                    <BlockRating rating={totalRatings.percent.presentation} />
                  </div>
                </li>
                <li>
                  <div
                    className="rating-block-container"
                    title={`Bei Lehrern ${roundNumber(teacherRatings.percent.presentation * 5)} Punkte von 5`}
                  >
                    <BlockRating rating={teacherRatings.percent.presentation} />
                  </div>
                </li>
                <li>
                  <div
                    className="rating-block-container"
                    title={`Bei Schülern ${roundNumber(pupilRatings.percent.presentation * 5)} Punkte von 5`}
                  >
                    <BlockRating rating={pupilRatings.percent.presentation} />
                  </div>
                </li>
              </ul>
            </dd>

            <dt>Räumliche Voraussetzungen</dt>
            <dd>
              <ul className="rating-chart">
                <li className="total">
                  <div className="rating-block-container"
                    title={`Insgesamt ${roundNumber(totalRatings.percent.spacial * 5)} Punkte von 5`}
                  >
                    <BlockRating rating={totalRatings.percent.spacial} />
                  </div>
                </li>
                <li>
                  <div className="rating-block-container"
                    title={`Bei Lehrern ${roundNumber(teacherRatings.percent.spacial * 5)} Punkte von 5`}
                  >
                    <BlockRating rating={teacherRatings.percent.spacial} />
                  </div>
                </li>
                <li>
                  <div className="rating-block-container"
                    title={`Bei Schülern ${roundNumber(pupilRatings.percent.spacial * 5)} Punkte von 5`}
                  >
                    <BlockRating rating={pupilRatings.percent.spacial} />
                  </div>
                </li>
              </ul>
            </dd>

            <dt>Gewinn der Veranstaltung</dt>
            <dd>
              <ul className="rating-chart">
                <li className="total">
                  <div
                    className="rating-block-container"
                    title={`Insgesamt ${roundNumber(totalRatings.percent.win * 5)} Punkte von 5`}
                  >
                    <BlockRating rating={totalRatings.percent.win} />
                  </div>
                </li>
                <li>
                  <div
                    className="rating-block-container"
                    title={`Bei Lehrern ${roundNumber(teacherRatings.percent.win * 5)} Punkte von 5`}
                  >
                    <BlockRating rating={teacherRatings.percent.win} />
                  </div>
                </li>
                <li>
                  <div
                    className="rating-block-container"
                    title={`Bei Schülern ${roundNumber(pupilRatings.percent.win * 5)} Punkte von 5`}
                  >
                    <BlockRating rating={pupilRatings.percent.win} />
                  </div>
                </li>
              </ul>
            </dd>
          </dl>
        </div>

        <div className="row section details">
          <div className="col-xs-offset-5 col-xs-7">
            <h5>Bewertungskommentare</h5>
            <ul className="nav-list comment-list">
              {comments.map((comment) => this.renderComment(comment))}
            </ul>
          </div>
        </div>
      </li>
    )
  }

}



// WEBPACK FOOTER //
// ./src/rating/components/ListEntry.js